import React from 'react';

const StatsTab = ({ employees, questions }) => {
  const totalQuestions = questions.length;
  const answered = questions.filter(q => q.status !== 'unanswered').length;
  const passed = questions.filter(q => q.status === 'passed').length;
  
  const employeeStats = employees.map(emp => {
      const assigned = questions.filter(q => q.assignedTo === emp.id);
      const answeredCount = assigned.filter(q => q.status !== 'unanswered').length;
      return { ...emp, assignedCount: assigned.length, answeredCount };
  });

  return (
    <div>
      <h2 className="text-2xl font-bold text-slate-800 mb-6">Performance Overview</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white p-5 rounded-xl shadow-sm">
            <h3 className="font-semibold text-slate-500">Total Questions</h3>
            <p className="text-4xl font-bold text-slate-800">{totalQuestions}</p>
        </div>
        <div className="bg-white p-5 rounded-xl shadow-sm">
            <h3 className="font-semibold text-slate-500">Answered</h3>
            <p className="text-4xl font-bold text-slate-800">{answered}</p>
        </div>
        <div className="bg-white p-5 rounded-xl shadow-sm">
            <h3 className="font-semibold text-slate-500">Passed</h3>
            <p className="text-4xl font-bold text-slate-800">{passed}</p>
        </div>
      </div>
      <h3 className="text-xl font-bold text-slate-800 mb-4">Employee Performance</h3>
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <table className="w-full text-left">
          <thead className="bg-slate-50">
            <tr>
              <th className="p-4 font-semibold text-slate-600">Employee</th>
              <th className="p-4 font-semibold text-slate-600">Assigned</th>
              <th className="p-4 font-semibold text-slate-600">Answered</th>
            </tr>
          </thead>
          <tbody>
            {employeeStats.map(emp => (
              <tr key={emp.id} className="border-t">
                <td className="p-4">{emp.name}</td>
                <td className="p-4">{emp.assignedCount}</td>
                <td className="p-4">{emp.answeredCount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StatsTab;
